import type { Theme } from '@mui/material';

export const styles = {
  tagCloudFilterGroup: (theme: Theme) => ({
    pb: 3,
    display: 'flex',
    gap: '0.75rem',
    flexDirection: 'column',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
    },
  }),
};
